<div
  class="modal-container"
  [ngClass]="{ 'challenge-invite': challengeInviteMessage && challengeId && challengeTitle }">
  <ng-container *ngIf="!proceedToLink && invite?.type !== inviteType.spouse; else inviteLink">
    <ng-container [ngSwitch]="invite?.type">
      <ng-container *ngSwitchCase="inviteType.coworker">
        <h2 class="title">Inviting Co-workers</h2>
        <p class="description">
          By continuing, you agree that the person you’re inviting to use Purposeful is an eligible employee of your
          sponsoring organization.
        </p>
      </ng-container>
      <ng-container *ngSwitchCase="inviteType.friend">
        <h2 class="title">Inviting Friends</h2>
        <p class="description">
          This link lets others access Purposeful up to the number of available friend invites you’ve accumulated.
        </p>
        <p class="description">
          To prevent others from using your invites, it’s best to only share this link privately with those you wish to
          invite.
        </p>
      </ng-container>
    </ng-container>
    <div class="button-row">
      <button class="button button-cancel" (click)="closeClicked.emit()">Cancel</button>
      <button class="button button-pill button-reverse button-proceed" (click)="proceedToLink = true">Got It</button>
    </div>
  </ng-container>

  <ng-template #inviteLink>
    <ng-container *ngIf="!challengeId && !challengeInviteMessage">
      <h2 class="title">Your Invite Link</h2>
      <p class="description">
        Share your unique invite link to give others access to Purposeful. Add a personal note to encourage others to
        give it a try!
      </p>
      <ng-container *ngIf="sharingBloc.shortLink$ | async as shortenedUrl">
        <input class="link-text" [value]="shortenedUrl" #sharingUrl readonly />
        <button
          [tp]="copyTooltip"
          tpTrigger="manual"
          [tpIsVisible]="showTooltip"
          class="button button-pill button-reverse button-invite"
          [ngClass]="{ 'button-appear-disabled': showTooltip }"
          (click)="copyLink(sharingUrl)">
          <svg-icon src="assets/icons/copy.svg"></svg-icon>
          Copy to Clipboard
        </button>
        <a
          class="button button-pill button-secondary-reverse button-invite"
          href="mailto:?subject={{ constants.inviteEmails?.[invite?.type]?.subject }}&body={{
          constants.inviteEmails?.[invite?.type]?.body + '%0D%0A%0D%0A' + shortenedUrl
        }}%0D%0A%0D%0A{{ (dataStoreService?.user$ | async)?.nickname }}">
          <svg-icon src="assets/icons/mail.svg"></svg-icon>
          Send via Email
        </a>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="challengeId && challengeInviteMessage">
      <h2 class="title">Challenge Invite Link</h2>
      <p class="description">
        Invite co-workers to join this Challenge with you on Purposeful. Add a personal note to encourage them to give
        it a try!
      </p>
      <ng-container *ngIf="sharingBloc.shortLink$ | async as shortenedUrl">
        <ng-container *ngIf="sharingBloc.challengeSharingLink$ | async as challengeUrl">
          <textarea class="link-text" readonly #challengeMessage
            >{{ challengeInviteMessage }}&#13;&#10;&#13;&#10;{{
              challengeUrl
            }}&#13;&#10;&#13;&#10;Don't have an account? Sign up here:&#13;&#10;{{ shortenedUrl }}&#13;&#10;&#13;&#10;{{
              (dataStoreService?.user$ | async)?.nickname
            }}</textarea
          >
          <button
            [tp]="copyTooltip"
            tpTrigger="manual"
            [tpIsVisible]="showTooltip"
            class="button button-pill button-reverse button-invite"
            [ngClass]="{ 'button-appear-disabled': showTooltip }"
            (click)="copyLink(challengeMessage)">
            <svg-icon src="assets/icons/copy.svg"></svg-icon>
            Copy to Clipboard
          </button>
          <a
            class="button button-pill button-secondary-reverse button-invite"
            href="mailto:?subject={{ challengeTitle }}&body={{
              challengeInviteMessage +
                '%0D%0A%0D%0A' +
                challengeUrl +
                '%0D%0A%0D%0A' +
                'Don\'t have an account? Sign up here:' +
                '%0D%0A' +
                shortenedUrl
            }}%0D%0A%0D%0A{{ (dataStoreService?.user$ | async)?.nickname }}">
            <svg-icon src="assets/icons/mail.svg"></svg-icon>
            Send via Email
          </a>
        </ng-container>
      </ng-container>
    </ng-container>
  </ng-template>
</div>

<ng-template #copyTooltip>Copied!</ng-template>
